import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-1 mt-10" }
const _hoisted_2 = { class: "max-w-[1126px] mx-auto px-6" }

import { useI18n } from 'vue-i18n';
import { useWindowSize } from '@vueuse/core';
import { computed } from 'vue';
import BaseTypography from '@/components/common/BaseTypography.vue';
import BaseReturn from '@/components/common/BaseReturn.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyPage',
  props: {
    title: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const title = computed(() => props.title ?? history.state?.title);

const { width } = useWindowSize();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseReturn, {
      text: title.value,
      class: "l:mb-[104px]"
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BaseTypography, {
        text: _unref(t)('empty-page'),
        type: _unref(width) < 768 ? 'subtitle2-m' : 'subtitle'
      }, null, 8, ["text", "type"])
    ])
  ]))
}
}

})